import IframeActivity from "./IframeActivity";

export default function BasketballManager() {
    return (
        <IframeActivity
            src="/activities/basketball-manager/index.html"
            title="Basketball Manager"
        />
    );
}